import type { PopoverConfig } from "./useDesktopPopoverCore"

export const tooltipConfig = {
  trigger: "mouseenter",
  interactive: false,
  tooltip: true,
  arrow: true,
  placement: "top",
  bodySpacing: false,
  appendToBody: true,
} satisfies Partial<PopoverConfig>
